import type { BaseController } from '@infra/controllers/base.controller';
import type { SetOutboundNumberUsecase } from '@usecases/set-outbound-number.usecase';

export type SetOutboundNumberInput = {
  number: string;
  lineId: number;
};

export type SetOutboundNumberOutput = void;

export class SetOutboundNumberController
  implements BaseController<SetOutboundNumberInput, SetOutboundNumberOutput>
{
  constructor(private usecase: SetOutboundNumberUsecase) {}

  async handle({
    number,
    lineId: id,
  }: SetOutboundNumberInput): Promise<SetOutboundNumberOutput> {
    await this.usecase.run({ number, id });
  }
}
